import React from 'react';
import data from '../../legal-content/data-protection.json';
import LegalDocument from '../../components/LegalDocument/LegalDocument';

const ProtectionDataPage = () => <LegalDocument data={data} currentPage="ProtectionDataPage" />;

export default ProtectionDataPage;
